module.exports = __webpack_public_path__ + "static/media/ic_status_design_outlined.ddd117bb.svg";